import React, { createContext, useContext, useState, useEffect } from 'react';

const FinancialYearContext = createContext(null);

export const useFinancialYear = () => {
  const context = useContext(FinancialYearContext);
  if (!context) {
    throw new Error('useFinancialYear must be used within a FinancialYearProvider');
  }
  return context;
};

// Helper to calculate current FY
const getCurrentFinancialYear = () => {
  const now = new Date();
  const year = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  return `${year}-${String(year + 1).slice(2)}`;
};

// Generate FY options (current + 4 previous years)
const generateFYOptions = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
  
  const options = [];
  for (let i = 0; i < 5; i++) {
    const year = startYear - i;
    options.push(`${year}-${String(year + 1).slice(2)}`);
  }
  return options;
};

export const FinancialYearProvider = ({ children }) => {
  // Initialize from localStorage or use current FY
  const [selectedFY, setSelectedFY] = useState(() => {
    const saved = localStorage.getItem('selectedFinancialYear');
    return saved || getCurrentFinancialYear();
  });

  const fyOptions = generateFYOptions();

  // Persist to localStorage when changed
  useEffect(() => {
    localStorage.setItem('selectedFinancialYear', selectedFY);
  }, [selectedFY]);

  const value = {
    selectedFY,
    setSelectedFY,
    fyOptions,
    currentFY: getCurrentFinancialYear()
  };

  return (
    <FinancialYearContext.Provider value={value}>
      {children}
    </FinancialYearContext.Provider>
  );
};

export default FinancialYearContext;
